module.exports = __webpack_public_path__ + "img/02.734c24b8.jpg";